import { useOtherSettings } from '@namespace/cms';
import {
  FAVORITE_CATEGORY,
  RECENTLY_PLAYED_CATEGORY,
  RECOMMENDED_CATEGORY
} from '../../constants';
import { useGamesStore } from '../../store';
import { useGetShowWagerSlotsCategory } from '../useGetShowWagerSlotsCategory';

export const useGetIsCustomCategory = (categoryId) => {
  const { casinoDynamicCategoriesIds = {} } = useOtherSettings();
  const showWagerSlotsCategory = useGetShowWagerSlotsCategory();
  const dynamicCategories = useGamesStore('dynamicCategories');

  const isDynamicCategory =
    (categoryId === casinoDynamicCategoriesIds?.wagerSlots &&
      dynamicCategories?.wagerSlotGames?.isLoaded &&
      dynamicCategories?.wagerSlotGames?.ids?.length) ||
    categoryId === casinoDynamicCategoriesIds?.liveRtp;

  return {
    isCustomCategory:
      categoryId === FAVORITE_CATEGORY.id ||
      categoryId === RECOMMENDED_CATEGORY.id ||
      categoryId === RECENTLY_PLAYED_CATEGORY.id ||
      isDynamicCategory,
    isCustomCategoryFlagCalculated:
      categoryId === casinoDynamicCategoriesIds?.wagerSlots &&
      showWagerSlotsCategory
        ? dynamicCategories?.wagerSlotGames?.isLoaded
        : true
  };
};
